import { useMemo } from "react";


export type ScriptProps = {
	js: string;
};
export const Script = ({ js }: ScriptProps) => useMemo(() => (
	<script dangerouslySetInnerHTML={{ __html: js }}/>
), [ js ]);
